module.exports = __webpack_public_path__ + "img/curve-shape-top.e8c9c876.svg";